import { FC } from "react";
import EmojiAvatar from "~/components/shared/EmojiAvatar";
import Emojify from "~/components/shared/Emojify";
import { ProcessedEmoji } from "~/components/shared/NavatarPicker/index";

export interface FooterSectionProps {
  displayEmoji?: ProcessedEmoji | null;
  selectedColor?: string | null;
  selectedEmoji?: string | null;
  onRemove?: () => void;
}

const FooterSection: FC<FooterSectionProps> = ({
  displayEmoji,
  selectedColor,
  selectedEmoji,
  onRemove,
}) => {
  return (
    <div className="flex h-20 w-full items-center justify-between border-t border-gray-200 bg-white px-4">
      <div className="flex items-center gap-2">
        <a
          href="https://github.com/buildkite/emojis#contributing-a-new-emoji"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-small btn-depth btn-flex text-nowrap"
        >
          Add Emoji
        </a>
        {selectedEmoji && onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="btn btn-small btn-depth btn-flex text-nowrap"
            data-testid="navatar-picker-remove"
          >
            Remove
          </button>
        )}
      </div>

      {displayEmoji && (
        <div className="flex h-fit min-w-0 items-center gap-2">
          <div className="flex min-w-0 flex-col items-end justify-center gap-1">
            <span className="text-charcoal-200 max-w-36 truncate text-right font-normal leading-none">
              {displayEmoji.name.replace(/-/g, " ")}
            </span>
            <span className="text-charcoal-400 max-w-36 truncate text-right text-xs font-normal leading-none">
              :{displayEmoji.name}:
            </span>
          </div>
          <EmojiAvatar
            emoji={`:${displayEmoji.name}:`}
            color={selectedColor}
            size="base"
            testId="navatar-picker-preview"
          />
        </div>
      )}
    </div>
  );
};

export default FooterSection;
